import React, { useState } from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'

import { SimCategoryList } from 'SharedComponents'
import CategoryContainerSimGolf from '../../containers/sim_golf/category_container_sim_golf'
import AddEditCategoryPopupSimGolf from './popups/add_edit_category_popup_sim_golf'
import {FaIcon} from "../../../shared/components";

const CategoryListComponentSimGolf = ({
  categories,
  reorderCategories,
  categoryIds,
  closeCategory,
  toggleCategory,
  reorderLeagues,
  name,
  opened,
  onClick,
  loadingData,
  color,
  deleteCategory,
  id,
  specialStatus,
  updateCategoriesSimGolf,
  updateURL,
  customerId,
  userIsCustomerManager,
}) => {
  const [drawerOpen, setDrawerOpen] = useState(false)
  const [displayPopup, setDisplayPopup] = useState(false)

  const handleDeleteCategory = () => {
    setDisplayPopup(false)
    deleteCategory(id)
  }

  const handleCategoriesSortEnd = (fromIndex, toIndex) => {
    reorderCategories(categoryIds[fromIndex], categoryIds[toIndex])
  }

  const handleLeaguesSortEnd = (fromIndex, toIndex, fromCategoryId, toCategoryId) => {
    if (toCategoryId.startsWith('header_')) {
      toCategoryId = toCategoryId.substr('header_'.length)

      if (fromCategoryId === toCategoryId) {
        return
      }

      setTimeout(() => {
        closeCategory(toCategoryId)
        toggleCategory(toCategoryId)
      }, 200)
    }
    reorderLeagues(fromIndex, toIndex, fromCategoryId, toCategoryId)
  }

  return (
    <span className='list_view_by_category_container'>
      <SimCategoryList
        items={ categoryIds.map(id => ({ id })) }
        itemComponent={ CategoryContainerSimGolf }
        isSortable={ true }
        onSortEnd={ handleCategoriesSortEnd }
        onNestedSortEnd={ handleLeaguesSortEnd }
      />
      <div className={`create_new_category_button ${userIsCustomerManager ? '' : 'hidden' }`} onClick={() => setDrawerOpen(true)}>
        <FaIcon icon={ 'square-plus-o' } />{ window.I18n.t('customer_center_comp.components.drawer.create_new_category') }
      </div>
      {drawerOpen &&
        <AddEditCategoryPopupSimGolf
          displayPopup={ drawerOpen }
          setDisplayPopup={ setDrawerOpen }
          title={ window.I18n.t('customer_center_comp.components.drawer.create_new_category') }
          categories={ categories }
          name={ name }
          opened={ opened }
          onClick={ onClick}
          loadingData={ loadingData }
          color={ color }
          deleteCategory={ handleDeleteCategory }
          id={ id }
          specialStatus={ specialStatus }
          displayDeletePopup={ displayPopup }
          setDisplayDeletePopup={ setDisplayPopup }
          updateCategoriesSimGolf={ updateCategoriesSimGolf }
          updateURL={updateURL}
          addNew={ true }
          customerId={ customerId }
        />
      }
    </span>
  )

}

CategoryListComponentSimGolf.propTypes = {
  categoryIds: PropTypes.array.isRequired,
  reorderCategories: PropTypes.func.isRequired,
  reorderLeagues: PropTypes.func.isRequired,
  closeCategory: PropTypes.func.isRequired,
  toggleCategory: PropTypes.func.isRequired,
  customerId: PropTypes.string.isRequired,
  categories: PropTypes.object.isRequired,
  userIsCustomerManager: PropTypes.bool.isRequired,
  name: PropTypes.string,
  opened: PropTypes.bool,
  onClick: PropTypes.func,
  loadingData: PropTypes.bool,
  color: PropTypes.string,
  deleteCategory: PropTypes.func,
  id: PropTypes.string,
  specialStatus: PropTypes.string,
  updateCategoriesSimGolf: PropTypes.func,
  updateURL: PropTypes.string,
}

export default CategoryListComponentSimGolf
